// Donor-scope donation detail API helper — CHG-1517 wave 2.
//
// Backend: portal.py canonical GET /api/v1/my-giving/donations/{id}
// returns PortalDonationDetailRead: {donation: PortalDonationRead,
// receipt: PortalReceiptRead | null}.

import { apiClient } from "./client";
import type { PortalDonationRead } from "./me-overview";

export interface PortalReceiptRead {
  id: string;
  donation_id: string;
  org_name: string | null;
  org_logo_url: string | null;
  receipt_number: string;
  // CHG-2912/CHG-2934 — NET deductible amount (gross minus refunded);
  // 0 for a voided (fully refunded) receipt.
  amount_minor_units: number;
  currency: string;
  issued_at: string;
  delivery_channel: string;
  delivery_status: string;
  pdf_url: string | null;
  // CHG-2934 (DP-R13.3) — tax-validity state (valid | voided |
  // partially_refunded) + cumulative refunded amount for the badge/caption.
  status: string;
  refunded_amount_minor_units: number;
}

export interface PortalDonationDetailRead {
  donation: PortalDonationRead;
  receipt: PortalReceiptRead | null;
}

export async function fetchMyDonationDetail(
  donationId: string,
): Promise<PortalDonationDetailRead> {
  const r = await apiClient().get<PortalDonationDetailRead>(
    `/my-giving/donations/${donationId}`,
  );
  return r.data;
}

export const meDonationDetailApi = {
  fetchMyDonationDetail,
};
